import axios from 'axios';
import environment from '@src/environment';
import optimizeCloudinaryUrl from '@src/utils/cloudinary-optimizations';

export const state = {
  unplannedRecipes: [],
  recipeDetailFull: null,
  recipeSource: {},
};

export const getters = {
  cachedRecipesMap: (state) => {
    const map = {};
    if (state.unplannedRecipes) {
      state.unplannedRecipes.forEach((element) => {
        map[element.id] = element;
      });
    }
    return map;
  },
};

export const mutations = {
  pushRecipe(state, recipe) {
    state.unplannedRecipes.push(recipe);
  },
  setRecipeDetailFull(state, value) {
    state.recipeDetailFull = value;
  },
  setRecipeSource(state, value) {
    state.recipeSource = value;
  },
};

export const actions = {
  async getRecipe(ctx, id) {
    return await axios
      .get(`${environment.RECIPES_URL}/${id}/details?isPremium=true`)
      .then((res) => {
        res.data.imageURL = optimizeCloudinaryUrl(res.data.imageURL);
        ctx.commit('pushRecipe', res.data);
        return res.data;
      })
      .catch((err) => console.log(err));
  },
  async getPublicRecipe(ctx, id) {
    return await axios
      .get(`${environment.PUBLIC_RECIPE_DETAIL}/${id}`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => console.log(err));
  },
  async getRecipeSourceHeaders(ctx, url) {
    return await axios
      .get(`${environment.RECIPE_SOURCE_HEADERS_URL}?sourceUrl=${url}`)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },
};
